import { toast } from "react-toastify";

const validate = (event, rules, type, name, showToast = true) => {
  const fieldNames = {
    Title: "Title",
    FirstName: "First Name",
    LastName: "Last Name",
    Gender: "Gender",
    DateOfBirth: "Date Of Birth",
    MobileNo1: "Contact No",
    EmergencyContactRelation: "Emergency Contact Relation",
    EmergencyPhoneNo: "Emergency Phone No",
    EmergencyContactName: "Emergency Contact Name",
    CorrespondenceAddress: "Correspondence Address",
    CorrespondenceCity: "Correspondence City",
    CorrespondenceState: "Correspondence State",
    CorrespondenceCountry: "Correspondence Country",
    PermanentAddress: "Permanent Address",
    PermanentCity: "Permanent City",
    employeeAttachments: "Employee Attachments",
    Qualification: "Qualifications",
    Identities: "Identities",
    employment_history: "Employment History",
    PFNomineeName: "PF Nominee Name",
    PFNomineeRelation: "PF Nominee Relation",
    BloodGroup: "Blood Group",
    TotalYearExp: "Total Years Experience",
    TotalMonthExp: "Additional Months Experience",
  };
  const alpha = /^[A-Za-z ]+$/;
  const bankAccount = /^\d{9,18}$/;
  const ifscCode = /^[A-Za-z]{4}\d{7}$/;
  const panno = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
  const gstno = /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/;
  let error = { status: false, message: "" };
  let value;
  switch (type) {
    case "dropdown":
      value = (event && typeof event === 'object' && event.value !== undefined) ? event.value : event;
      break;
    case "city":
      value = (event && typeof event === 'object' && event.value !== undefined) ? event.value : event;
      break;
    case "state":
      value = (event && typeof event === 'object' && event.value !== undefined) ? event.value : event;
      break;
    case "country":
      value = (event && typeof event === 'object' && event.value !== undefined) ? event.value : event;
      break;
    case "input":
      value = event?.target?.value;
      break;
    case "datepicker":
      value = event;
      break;
    case "input-submit":
      value = event;
      break;
    case "mobile":
      value = event;
      break;
    case "line-level":
      value = event;
      break;
  }
  for (let i = 0; i < rules.length; i++) {
    switch (rules[i]) {
      case "required":
        if (!value || value == "") {
          error = {
            status: true,
            message: `${fieldNames[name] || "This field"} is required`,
          };
        }
        break;
      case "alpha":
        if (value && !value.match(alpha)) {
          error = { status: true, message: `${fieldNames[name] || "Field"}: only alphabets are allowed` };
        }
        break;
      case "bank-account-no":
        if (value && !value.match(bankAccount)) {
          error = { status: true, message: `Valid bank account no required` };
        }
        break;
      case "ifsc":
        if (value && !value.match(ifscCode)) {
          error = { status: true, message: `Valid IFSC code required` };
        }
        break;
      case "pan-no":
        if (!value.match(panno) && value != "") {
          error = { status: true, message: `Valid PAN No. required` };
        }
        break;
      case "gst-no":
        if (!value.match(gstno) && value != "") {
          error = { status: true, message: `Valid GSTIN No. required` };
        }
        break;
      case "min1":
        if (!value || value.length == 0) {
          error = {
            status: true,
            message: `${fieldNames[name] || "This section"} requires at least one record`,
          };
        }
        break;
      case "min3":
        if (!value || value.length < 3) {
          error = {
            status: true,
            message: `${fieldNames[name] || "This section"} requires at least 3 records (e.g. 10th, 12th, Degree)`,
          };
        }
        break;
    }
  }
  if (error.status && showToast) {
    toast.error(error.message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
  return error;
};
export default validate;
